import React from 'react';
import { isSite as getIsSite } from '../../store/basic-params/basic-params-selectors';
import { useActions, useSelector } from '../runtime-context';

type Props = {
  path: string;
  sectionId?: string;
  onClick?: () => void;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'onClick'>;

const BaseLink: React.FC<Props> = ({
  path,
  sectionId,
  children,
  onClick,
  ...rest
}) => {
  const isSite = useSelector(getIsSite);
  const actions = useActions();

  const handleClick: React.MouseEventHandler = (event) => {
    if (!isSite && sectionId) {
      event.preventDefault();
      actions.navigateToSectionInPreview(path, sectionId);
      return;
    }

    onClick?.();
  };

  return (
    <a {...rest} onClick={handleClick}>
      {children}
    </a>
  );
};

export default BaseLink;
